<script>
import ChanelDonut from "@/components/chanelDonut";

export default {
  components: { ChanelDonut },

  props: {
    browserFrequency: {
      type: Object,
      default: () => null,
    },
  },
  
  computed: {

    browserFrequencyData() {
      return Object.values(this.browserFrequency); 
    },
    browserFrequencyLabels() {
      return Object.keys(this.browserFrequency); 
    },
  },
};
</script>

<template>
  <div class="card" v-if="browserFrequency &&  browserFrequencyData && browserFrequencyLabels"  style="border:1px solid #ddd;">
    <div class="card-body " >

      <h4 class="text-dark text-uppercase font-weight-bold">{{$t('reporting.customer.browserType')}}</h4>


      <ChanelDonut 
      :data="browserFrequencyData" 
      :labels="browserFrequencyLabels" 
    />
    </div>
  </div>
</template>
